var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stream"},[_c('blocks-container',{attrs:{"blocks":_vm.blocks,"unlock":_vm.unlock},on:{"init":_vm.handleContainerInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }